import Papa, { ParseResult } from "papaparse";
import { message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { createTopSkill } from "../core/data/redux/employee/employeeAction";

export const useSkillCSVImport = (
    setTableKey: React.Dispatch<React.SetStateAction<number>>
) => {
    const dispatch = useDispatch<any>();
    const { user } = useSelector((state: any) => state.auth);
    const { employees } = useSelector((state: any) => state.employee);

    const normalize = (str: string) =>
        (str || "").replace(/\s+/g, " ").trim().toLowerCase();

    const handleSkillCSVImport = (file: File) => {
        message.loading({ content: "Importing skills...", key: "skill_import" });

        Papa.parse(file, {
            header: true,
            skipEmptyLines: true,

            complete: async function (results: ParseResult<any>) {
                const rows = results.data as any[];

                let valid = 0;
                let invalid = 0;

                for (let row of rows) {
                    // --- Get EmployeeId from CSV ---
                    let employeeId =
                        row.EmployeeId ||
                        row.EmployeeID ||
                        row.employeeID;

                    // --- If CSV only contains Employee Name ---
                    if (!employeeId && row.Employee) {
                        const emp = employees?.find(
                            (e: any) =>
                                normalize(`${e.FirstName || ""} ${e.LastName || ""}`) ===
                                normalize(row.Employee)
                        );

                        employeeId = emp?.EmployeeID || null;
                    }

                    if (!employeeId) {
                        invalid++;
                        message.warning(
                            `Skipping row: Employee not found for ${row.Employee || "unknown"}`
                        );
                        continue;
                    }

                    // Build Skill Payload
                    const skillPayload = {
                        SkillName: row.SkillName,
                        ProficiencyScore: Number(row.ProficiencyScore) || 0,
                        CreatedBy: row.CreatedBy || user?.id,
                    };

                    // API call
                    const response = await dispatch(
                        createTopSkill({
                            employeeId,
                            topSkillData: skillPayload,
                        })
                    );

                    if (createTopSkill.rejected.match(response)) invalid++;
                    else valid++;
                }

                setTableKey((prev) => prev + 1);

                message.success({
                    content: `Skill Imported: ${valid}, Skipped: ${invalid}`,
                    key: "skill_import",
                    duration: 3,
                });
            },
        });
    };

    return { handleSkillCSVImport };
};

